import { render, staticRenderFns } from "./describe.vue?vue&type=template&id=54553953&scoped=true"
import script from "./describe.vue?vue&type=script&lang=ts"
export * from "./describe.vue?vue&type=script&lang=ts"
import style0 from "./describe.vue?vue&type=style&index=0&id=54553953&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54553953",
  null
  
)

export default component.exports